




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { renderBool } from '@/utils/renderer';
import { initPageParams } from '@/utils/constants';
import { IPageParam } from '@/store/types';
import { IAuthedBrandRecord } from '@/store/organization/org/types';
import { IActions, IConfirm, IOrgAuthPage } from '@/store/brand-audit/auth/types';
import PageList from '@/components/page/Index.vue';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';

const Auth = namespace('brandAudit/auth');

// 指定品牌下已授权的组织列表
@Component({
  components: { PageList, TooltipIcon },
})
export default class EnterpriseOrgAuth extends Vue {
  @Auth.Action('queryAuthOrgPage') public queryAuthedOrgPage!: IActions['queryAuthOrgPage'];
  @Auth.State('authOrgPage') public list!: IOrgAuthPage;
  
  @Auth.Action('deleteOrgAuth') public deleteOrgAuth!: IActions['deleteOrgAuth'];

  @Auth.Mutation('setConfirm') public setConfirm!: IActions['setConfirm'];
  @Auth.State('confirm') public confirm!: IConfirm;

  @Prop() public dataItem!: IAuthedBrandRecord;

  public selection: any = null;
  public listParams = { ...initPageParams, brandId: -1 };

  public headers = [
    { text: '组织编码/登录名称', value: 'orgCode' },
    { text: '组织名称/会员昵称', value: 'name' },
    { text: '组织状态', value: 'orgStatusDisplay' },
    { text: '是否品牌拥有者', value: 'isOwner' },
    { text: '操作', value: 'action', width: '60px' },
  ];

  public get brandId() {
    return this.dataItem?.id || null;
  }

  // 是否显示'取消授权'操作按钮
  public showDelete(record: any) {
    return !record.isOwner;
  }

  public renderIsOwner(record: any) {
    return renderBool(record.isOwner, { trueColor: 'red--text' });
  }

  public onCancelAuth(record: any) {
    const content = '是否确认取消此组织的授权？'
    this.selection = record;
    this.setConfirm({ visible: true, title: '取消授权', content });
  }

  public onPageChange(pagination: IPageParam) {
    this.listParams = { ...this.listParams, ...pagination };
    this.queryAuthedOrgPage(this.listParams);
  }

  // 确认取消授权
  public async onConfirm(ok: boolean) {
    if (!ok) {
      this.selection = null;
      this.setConfirm({ visible: false });
      return;
    }

    if (this.selection) {
      const { authorizedOrgId, brandId } = this.selection;
      await this.deleteOrgAuth({ authorizedOrgId, brandId });
      this.queryAuthedOrgPage(this.listParams);
    }
  }

  @Watch('brandId', { immediate: true })
  public watchBrandId(brandId: number | null) {
    if (brandId) {
      this.listParams = { ...this.listParams, brandId };
      this.queryAuthedOrgPage(this.listParams);
    }
  }
}
